import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Prioritise an explicit user choice (persisted in localStorage)
      // over the browser locale. Without this order, a user who toggled
      // FR in the UI would be reverted to `navigator.language` on every
      // fresh session. `caches: ['localStorage']` only decides where the
      // language is written; `order` decides where it is read first.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
